import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main message" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "additional message" }
const _hoisted_4 = { class: "text" }

import { useState } from "@/composables/useState";
    import { onMounted, ref, watch } from "vue";
    import gsap from "gsap";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TowerMessage',
  setup(__props) {

    const { useMetadata } = useState();
    const metadata = useMetadata();

    const stateClass = ref("state-1");

    const message = ref({
        main: "",
        additional: "",
    });

    const onStatusUpdate = (o: string, n: string) => {
        console.log("TrackStatus Updated!", o, n);

        const hide = (type: "main" | "additional", cb?: () => void) => {
            const el = `.tower-message-container .${type}.message`;

            gsap.to(el, {
                height: 0,
                duration: 1,
                ease: "expo.inOut",
                onComplete: () => {
                    if (cb) cb();
                },
            });

            gsap.to(el + " .text", {
                clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
                duration: 1,
                ease: "expo.inOut",
            });
        };

        const show = (
            msg: string,
            type: "main" | "additional",
            h: number = 80,
            cb?: () => void
        ) => {
            const el = `.tower-message-container .${type}.message`;

            console.log("show", h);

            message.value[type] = msg;

            gsap.to(el, {
                height: h,
                duration: 1,
                ease: "expo.inOut",
                onComplete: () => {
                    if (cb) cb();
                },
            });

            gsap.to(el + " .text", {
                clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0 100%)",
                duration: 1,
                ease: "expo.inOut",
            });
        };

        const states = {
            "1": [
                {
                    type: "main",
                    action: "hide",
                },
                {
                    type: "additional",
                    action: "hide",
                },
            ],
            "2": [
                {
                    type: "main",
                    h: 80,
                    message: "YELLOW FLAG",
                    ignoreHide: ["6"],
                    action: "show",
                },
                {
                    type: "additional",
                    action: "hide",
                },
            ],
            "6": [
                {
                    type: "main",
                    h: 80,
                    message: "YELLOW FLAG",
                    ignoreHide: ["2"],
                    action: "show",
                },
                {
                    type: "additional",
                    h: 30,
                    message: "VIRTUAL SAFETY CAR",
                    ignoreHide: [],
                    action: "show",
                },
            ],
            "7": [
                {
                    type: "main",
                    action: "hide",
                },
                {
                    type: "additional",
                    h: 30,
                    message: "VSC ENDING",
                    ignoreHide: [],
                    action: "show",
                },
            ],
        };

        // @ts-ignore
        const actions = states[n];

        for (let action of actions) {
            if (action.action == "show") {
                if (action.ignoreHide.indexOf(o) > -1) {
                    stateClass.value = "state-" + n;
                    show(action.message, action.type, action.h);
                } else {
                    hide(action.type, () => {
                        stateClass.value = "state-" + n;
                        show(action.message, action.type, action.h);
                    });
                }
            } else if (action.action == "hide") {
                hide(action.type);
            }
        }
    };

    onMounted(() => {
        // Run on load as well
        onStatusUpdate("1", metadata.value.liveTimingState.TrackStatus.Status);
        watch(
            () => metadata.value.liveTimingState.TrackStatus.Status,
            (n, o) => {
                onStatusUpdate(o, n);
            }
        );
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tower-message-container", stateClass.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(message.value.main), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(message.value.additional), 1)
    ])
  ], 2))
}
}

})